export const contacts = state => state.getIn(['contacts', 'entities']);
export const contactById = (state, id) => contacts(state).get(String(id));
export const contactsByIds = (state, ids) => ids.map(id => contactById(state, id));
export const contactByPersonId = (state, id) =>
  contacts(state).find(contact => contact.person === id);
